import React, { Component } from 'react';
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles';

import DashboardLayout from '../DashboardLayout';
import PaymentMethodCard from './PaymentMethodCard';
import BillingAdressCard from './BillingAdressCard';


/** 
 * BillingInfo page component.
 * Displays a Payment method card and a billing adress card
*/

const styles = theme => ({
  card: {
    maxWidth: 400, 
    marginRight:24,
  },
  title: {
    display:'flex', 
    justifyContent:'center', 
    marginBottom:36, 
    marginTop:36
  },
  defaultText: {
    color: '#797979',
    fontWeight: 300
  },
  content: {
    display:'flex', 
    flexDirection:'row', 
    justifyContent:'center',
  }
})

class BillingInfoPage extends Component {

  render() {
    const {classes} =this.props;
    return (
        <DashboardLayout  >
            <div className={classes.title}>
              <Typography variant="h4" className={classes.defaultText} >Billing Information: </Typography>
            </div>
            <div className={classes.content}>
              
              <div className={classes.card}>
                <PaymentMethodCard />
              </div>
              <div className={classes.card}>
                <BillingAdressCard />
              </div>
            </div>
        </DashboardLayout>
    )
  }

}

export default withStyles(styles)(BillingInfoPage); 


// WEBPACK FOOTER //
// ./src/components/billingInfo/BillingInfoPage.js